import styled from 'styled-components';

import style from '../../../style';
import { StyledBorder } from './components/Border.styled';

export const InputHidden = styled.input(() => ({
  width: '100%',
  height: '100%',
  display: 'none',
}));

export const Wrapper = styled.div<{
  $transparentBackground?: boolean;
  $clickDisabled?: boolean;
}>(
  ({
    theme: { color, borderRadius, size },
    $transparentBackground = false,
    $clickDisabled = false,
  }) => ({
    backgroundColor: $transparentBackground
      ? 'transparent'
      : color.background.quaternary.default(),
    borderRadius: borderRadius.medium,
    cursor: $clickDisabled ? undefined : 'pointer',
    width: '100%',
    height: '100%',
    padding: size.units(1),
    minHeight: 'auto',

    ...style.mixins.devices.desktop({
      '&:hover': {
        [StyledBorder]: {
          stroke: color.border.primary.hover(),
          strokeDashoffset: 100,
        },
      },
    }),
  }),
);

export const InternalComponentContainer = styled.div(() => ({
  zIndex: 1,
}));

export const DraggingComponentContainer = styled(InternalComponentContainer)({
  pointerEvents: 'none',
  zIndex: 2,
});

export const Label = styled.label<{
  $clickDisabled?: boolean;
}>(({ theme: { size }, $clickDisabled = false }) => ({
  position: 'relative',
  cursor: $clickDisabled ? undefined : 'pointer',
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  height: '100%',
  padding: `${size.units(1.5)} ${size.units(2)}`,

  [InternalComponentContainer]: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
}));

export const BaseDropAreaWrapper = styled.div(({ theme: { borderRadius } }) => ({
  borderRadius: borderRadius.medium,
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  position: 'relative',

  [StyledBorder]: {
    position: 'absolute',
  },

  [Label]: {
    zIndex: 1,
  },
}));
